export default __webpack_public_path__ + "cf2e65a62c303d41c1a37a04c69cd4c2.png";